import ErrorMessage from 'components/ErrorMessage';
import { title } from 'process';
import { forwardRef } from 'react';
type InputProps = {
  id?: string;
  type?: string;
  title?: string;
  errors?: any;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};

const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return (
    <div>
      <div className='mt-1'>
        <input
          {...props}
          type={props.type}
          id={props.id}
          ref={ref}
          required
          placeholder={props.title}
          className='auto-complete-non bg-transparent block w-full p-2 rounded-lg border border-zinc-500 placeholder-zinc-600 focus:outline-none focus:border-zinc-700 sm:text-sm'
        />
      </div>
      {props.errors && <ErrorMessage msg={props.errors.message} />}
    </div>
  );
});
Input.displayName = 'InputTemplate';
export default Input;
